import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import BottomHeader from './Bottom';

const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: '#F5F5F5';
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderOnlineMediaStatisticRetail() {
  return (
    <>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item xs={12}>
            <BottomHeader />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
}

export default HeaderOnlineMediaStatisticRetail;
